export const locale = {
    lang: 'tr',
    data: {
        'NAV': {
            'APPLICATIONS': 'Programlar',
            'HOME'        : {
                'TITLE': 'Örnek',
                'BADGE': '15'
            }
        }
    }
};
